const Loader = () => {
  return (
    <div className="loader-container my-6">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
